<footer>
  <div class="footer-container">
    <app-mq-footer-sir-contact></app-mq-footer-sir-contact>
    <app-mq-footer-sir-social [socialLinks]="(brandInfo$ | async).brandLinks"></app-mq-footer-sir-social>
    <app-mq-footer-sir-disclaimer [copyrightText]="(this.brandInfo$ | async).copyright"></app-mq-footer-sir-disclaimer>
  </div>
</footer>
